import {
  adaptSonarToStore,
  adaptSonarListToStore,
  adaptSonarFetchToStore,
  adaptSonarToApi,
} from './adapters/sonarAdapter'

import { CONTENT_BACKOFFICE } from '@/services/axios.config'
import { buildHeaders } from './utils/build_headers'
import buildParamList from './utils/build_params'
import { buildServices } from './utils/build_services'
import isEmpty from 'lodash.isempty'
import omitBy from 'lodash.omitby'

const services = [
  {
    name: 'listSonar',
    method: 'get',
    url: (params) => `/sonar/skill-areas${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptSonarListToStore
  },
  {
    name: 'getSonar',
    method: 'get',
    url: (params) => `/sonar/skill-areas/${params.sonarId}`,
    resolver: adaptSonarToStore,
  },
  {
    name: 'createSonar',
    method: 'post',
    url: () => `/sonar/skill-areas`,
    data: (params) => {
      return adaptSonarToApi(params)
    },
  },
  {
    name: 'editSonar',
    method: 'patch',
    url: (params) => `/sonar/skill-areas/${params.sonarId}`,
    data: (params) => {
      return adaptSonarToApi(params)
    },
  },
  {
    name: 'getSonarAssessmentID',
    method: 'get',
    url: (params) => `/argus/skill-areas?skill_area_id=${params.sonarId}`,
    resolver: adaptSonarFetchToStore,
  },
  {
    name: 'listSonarLAreas',
    method: 'get',
    url: () => `/sonar/learning-area-groups`,
  }
]

export const {
  getSonarAssessmentID,
  listSonarLAreas,
  createSonar,
  editSonar,
  listSonar,
  getSonar,
} = buildServices(CONTENT_BACKOFFICE, services)
